import { createAction, props } from '@ngrx/store';


export const selectCustomer = createAction('[Customer List] select Customer', props<{customerId: string}>());
export const loadCustomers = createAction('[Customer List] load all customers');
export const applyFilter = createAction('[Customer List] apply filiter', props<{search: string}>());
